/**
 * Generate a placeholder image URL using a service or create SVG data URL
 */
export const getPlaceholderImage = (width = 800, height = 600, text = 'Image') => {
  // Create SVG placeholder
  const svg = `
    <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
      <rect width="100%" height="100%" fill="#e9ecef"/>
      <text 
        x="50%" 
        y="50%" 
        dominant-baseline="middle" 
        text-anchor="middle" 
        font-family="Space Grotesk, Arial, sans-serif" 
        font-size="24" 
        fill="#6c757d"
      >${text}</text>
    </svg>
  `;
  
  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

/**
 * Check if image URL is valid and exists
 */
export const validateImageUrl = (url) => {
  if (!url || url.trim() === '') return false;
  
  // Check if it's a data URL
  if (url.startsWith('data:')) return true;
  
  // Check if it's a valid URL format
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

/**
 * Get image URL with fallback to placeholder
 */
export const getImageWithFallback = (url, width = 800, height = 600, text = 'No Image') => {
  return validateImageUrl(url) ? url : getPlaceholderImage(width, height, text);
};